import { jwtDecode } from "jwt-decode";

export type DecodedToken = {
  id: string;
  name?: string;
  email?: string;
  Roles : string;
  Permission: string[]; 
  exp?: number; // Expiration time (optional)
  [key: string]: any; // For additional properties
  aud: string;
  iss: string; 
};

/**
 * Decodes a JWT token and returns the payload.
 * @returns DecodedToken | null
 */
export const decodeJwtToken = (): DecodedToken | null => {
  try {
    const token = localStorage.getItem("accessToken"); // Get the token from localStorage
    if (!token) {
      console.warn("No access token found in localStorage");
      return null;
    }

    const decoded: DecodedToken = jwtDecode(token); // Decode the token
    return decoded;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};
